import axios from 'axios';

const getSkippers = async function dashboardServiceGetSkippers () {
  const response = await axios.get('/api/statistics/skippers');

  return Object.freeze(response.data.data);
};

const getProjects = async function dashboardServiceGetProjects (params) {
  const response = await axios.get('/api/statistics/projects', { params });

  return Object.freeze(response.data.data);
};

const projectInfo = async function dashboardServiceProjectInfo (id) {
  const response = await axios.get(`/api/project/${id}`);

  return Object.freeze(response.data.data);
};

const projectSummary = (
  async function dashboardServiceProjectSummary (id, params) {
    const response = await axios.get(
      `/api/statistics/project/${id}`,
      { params },
    );

    return response.data.data;
  }
);

const projectDepartmentsHistory = (
  async function dashboardServiceProjectDepartmentsHistory (id, filters = {}) {
    const response = await axios.get(
      `/api/statistics/project/${id}/departmentsHistory`,
      { params: filters },
    );

    return response.data;
  }
);

const projectDepartments = async function dashboardServiceProjectDepartments (
  id,
  filters = {},
) {
  const response = await axios.get(
    `/api/statistics/project/${id}/departments`,
    { params: filters },
  );

  return response.data;
};

const projectWorkers = async function dashboardServiceProjectWorkers (
  id,
  filters = {},
) {
  const response = await axios.get(
    `/api/statistics/project/${id}/workers`,
    { params: filters },
  );

  return response.data;
};

const getWorkersList = async function workersServiceGetList (params) {
  const response = await axios.get('/api/statistics/workers', { params });

  return Object.freeze(response.data.data);
};

const getWorkerById = async function workersServiceGetById (id) {
  const response = await axios.get(`/api/worker/${encodeURIComponent(id)}`);

  return response.data.data;
};

const getWorkerStatistics = async function dashboardServiceGetWorkerStatistics (
  id,
  params = {},
) {
  const response = await axios.get(`/api/statistics/worker/${id}`, { params });

  return response.data.data;
};

export default {
  getSkippers,
  getProjects,
  getWorkersList,
  getWorkerById,

  projectInfo,
  projectSummary,
  projectDepartmentsHistory,
  projectDepartments,
  projectWorkers,

  getWorkerStatistics,
};
